import requests from './request';

// 获取商品列表
export const reqGetGoodsList = (params)=>requests({url:'/customer/goods/getGoodsList', method:'post', data:params});
